import { useEffect, useState } from "react"
import styles from 'styles/Schedule.module.css';
import TopScheduleLogo from 'assets/images/schedule/top_schedule.png';
import AreaCupThumbnail from 'assets/images/news/AREA_CUP_logo_original.png';
import CanvasCupThumbnail from 'assets/images/tournaments/canvas_cup.png';
import ZenkaiThumbnail from 'assets/images/tournaments/zenkai.png';
import { ScheduleData, PreviousScheduleData } from 'interfaces/schedule';
import { getSchedules, getPreviousSchedule } from 'lib/api/schedule';


const Schedule = () => {
  const [scheduleData, setScheduleData] = useState<ScheduleData[]>([]);
  const [previousScheduleData, setPreviousScheduleData] = useState<PreviousScheduleData | undefined>();
  const handleGetSchedules = async () => {
    const res = await getSchedules()

    if (res.status == 200) {
      setScheduleData(res.data)
    }
  }

  const handleGetPreviousSchedule = async () => {
    const res = await getPreviousSchedule()

    if (res.status == 200) {
      setPreviousScheduleData(res.data)
    }
  }

  useEffect(() => {
    handleGetSchedules()
    handleGetPreviousSchedule()
  }, [])

  const formatDate = (dateInput: Date): string => {
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
  
    return `${year}/${month}/${day}`;
  }

  const newMonthDate = (dateInput: Date): string => {
    const targetDate = dateInput instanceof Date ? dateInput : new Date(dateInput);
    const targetMonth = targetDate.getMonth() + 1;
    return `${targetMonth}`;
  }

  const getThumbnail = (event: ScheduleData) => {
    if (event.tournamentSeriesNameId == "areacup") {
      return AreaCupThumbnail;
    } else if (event.tournamentSeriesNameId == "canvascup") {
      return CanvasCupThumbnail;
    } else if (event.tournamentSeriesNameId == "zenkai") {
      return ZenkaiThumbnail;
    } else {
      return AreaCupThumbnail;
    }
  };

  const isValidYoutubeEmbedUrl = (url: string | undefined): boolean => {
    if (!url) return false;
    const youtubeEmbedRegex = /^https:\/\/www\.youtube\.com\/embed\/[a-zA-Z0-9_-]+(\?.*)?$/;
    return youtubeEmbedRegex.test(url);
  };

  return (
    <div className={styles["schedule-background"]} id="schedule">
      <div>
        <img src={TopScheduleLogo} className={styles["schedule-logo"]} alt="大会スケジュール" />
      </div>
      <div className={styles["schedule-container"]}>
        <div className={styles["today-event"]}>
          <h2>
            前回の大会
          </h2>

          <div className={styles["flex-container"]}>
            <div className={styles["left-content"]}>
            {previousScheduleData 
                ? previousScheduleData.tournamentNameJa
                : "AREA CUP 1st."
            }

            </div>
            <div className={styles["right-content"]}>{/* 21:00 START */}</div>
          </div>
          
          <div className={styles["event-buttons"]}>
            {/* <button className={styles["event-button"]}>申請フォーム ⟶</button> */}
            {/* <button className={styles["event-button"]}>対戦表 ⟶</button> */}
          </div>
        </div>
        <div className={styles["event-image"]}>
          {isValidYoutubeEmbedUrl(previousScheduleData?.streamUrl) ? (
            <iframe
              src={previousScheduleData?.streamUrl}
              title="大会配信"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          ) : (
            <img src={AreaCupThumbnail} />
          )}
        </div>
      </div>
      
      
      <div className={styles["schedule-container2"]}>
        <div className={styles["horizontal-text"]}>
          開催予定の大会
        </div>
        <div className={styles["vertical-text"]}>
          開催予定の大会
        </div>
        <div className={styles["event-list"]}>
        {scheduleData && scheduleData.length > 0 ? (
          scheduleData.map((event, index) => (
            <>
              {event.isNewMonth &&
                <div className={styles["event-bunkatu"]}>
                </div>
              }
              <div className={styles["event-card"]} key={index}>
                <h3 className={styles["event-month"]}>
                  {event.isNewMonth &&
                    <>{newMonthDate(event.dateOn)}<span>月</span></>
                  }
                  {!event.isNewMonth &&
                    <>&nbsp;</>
                  }
                </h3>
                <img
                  src={getThumbnail(event)}
                  alt={event.tournamentNameJa}
                  className={styles["event-image"]}
                />
                <div className={styles["event-info"]}>
                  <h3 className={styles["event-title"]}>{event.tournamentNameJa}</h3>
                  <p className={styles["event-date"]}>{formatDate(event.dateOn)}&nbsp;&nbsp;&nbsp;20:00 START</p>
                  {/* <button className={styles["event-status"]}>申請期間</button> */}
                </div>
              </div>
            </>
          ))
        ) : (
          <p>現在、予定されている大会はありません。</p>
        )}
        </div>
      </div>
    </div>
  );
};

export default Schedule;
